var map = {
	"./download-tipicon1.png": 7915,
	"./download-tipicon2.png": 4096,
	"./recommend-en.png": 9837,
	"./recommend-zh.png": 2462,
	"./tabs-android-img-active.png": 4052,
	"./tabs-android-img-active_1.png": 5284,
	"./tabs-android-img.png": 4191,
	"./tabs-ios-img-active.png": 1490,
	"./tabs-ios-img-active_1.png": 2982,
	"./tabs-ios-img.png": 2737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;